<template>
  <v-tabs v-model="tabMenu">
    <v-tabs-slider color="primary"></v-tabs-slider>
    <v-tab @click="resetTab()">Commission Rate</v-tab>
    <v-tab v-show="commissionReviewTab" @click="resetTab(2)">{{ ids.commissionNo !== 'new' ? 'Commission Info / Overriding Agent List' : 'New Commission' }}</v-tab>
    <v-tab v-show="overridingAgtReviewTab" @click="resetTab(3)">{{ ids.ovrInter !== 'new' ? 'Overriding Agent Info / Risk Item List' : 'New Overriding Agent' }}</v-tab>
    <!-- <v-tab v-show="itemReviewTab" @click="resetTab(4)">{{ ids.itemNo !== 'new' ? 'Risk Item Info /Risk SubItem List' : 'New Package Risk Item' }}</v-tab>
    <v-tab v-show="subItemReviewTab">{{ ids.subItemNo !== 'new' ? 'Risk SubItem Info' : 'New Risk SubItem' }}</v-tab> -->
    <v-tab-item>
      <commission-list :fetchCommission="fetchCommission" :inter="inter" :interGroupCode="interGroupCode" @doReview="doCommissionReview" @doQuery="doCommissionQuery" @doNew="doCommissionNew"></commission-list>
    </v-tab-item>
    <v-tab-item>
      <commission-form :ids="ids" @resetTab="resetTab"></commission-form>
      <overriding-agt-list v-show="ids.commissionNo !== 'new'" :fetchOverridingAgt="fetchOverridingAgt" :ids="ids" @doReview="doOverridingAgtReview" @doQuery="doOverridingAgtQuery" @doNew="doOverridingAgtNew"></overriding-agt-list>
    </v-tab-item>
    <v-tab-item>
      <overriding-agt-form :ids="ids" @resetTab="resetTab"></overriding-agt-form>
      <!-- <pkg-risk-item-list v-show="ids.ovrInter !== 'new'" :ids="ids" :fetchItem="fetchItem" @doReview="doItemReview" @doNew="doItemNew"></pkg-risk-item-list> -->
    </v-tab-item>
    <!--
    <v-tab-item>
      <pkg-risk-item-form :ids="ids" @resetTab="resetTab"></pkg-risk-item-form>
      <pkg-risk-sub-item-list v-show="ids.itemNo !== 'new'" :ids="ids" :fetchSubItem="fetchSubItem" @doReview="doSubItemReview" @doNew="doSubItemNew"></pkg-risk-sub-item-list>
    </v-tab-item>
    <v-tab-item>
      <pkg-risk-sub-item-form :ids="ids" @resetTab="resetTab"></pkg-risk-sub-item-form>
    </v-tab-item> -->
  </v-tabs>
</template>

<script>
import CommissionList from '../list/CommissionList'
import OverridingAgtList from '../list/OverridingAgtList'
// import PkgRiskList from './list/PkgRiskList'
// import PkgRiskItemList from './list/PkgRiskItemList'
// import PkgRiskSubItemList from './list/PkgRiskSubItemList'
import CommissionForm from '../form/CommissionForm'
import OverridingAgtForm from '../form/OverridingAgtForm'
// import PkgRiskForm from './form/PkgRiskForm'
// import PkgRiskItemForm from './form/PkgRiskItemForm'
// import PkgRiskSubItemForm from './form/PkgRiskSubItemForm'

export default {
  data() {
    return {
      tabMenu: 0,
      commissionReviewTab: false,
      overridingAgtReviewTab: false,
      // itemReviewTab: false,
      // subItemReviewTab: false,
      fetchCommission: false,
      fetchOverridingAgt: false,
      // fetchItem: false,
      // fetchSubItem: false,
      ids: {
        inter: null,
        interGroupCode: null,
        commissionNo: null,
        effDate: null,
        polType: null,
        queryCommission: null,
        ovrInter: null,
        queryOvrAgt: null
        // itemNo: null,
        // subItemNo: null
      }
    }
  },
  computed: {
    schemeMenu() {
      return this.$store.state.parameters.scheme.schemeMenu
    }
  },
  methods: {
    async resetTab(tab) {
      switch (tab) {
        case 4: {
          this.tabMenu = 3
          // this.ids.subItemNo = null
          this.commissionReviewTab = true
          this.overridingAgtReviewTab = true
          // this.itemReviewTab = true
          // this.subItemReviewTab = false
          this.fetchCommission = false
          this.fetchOverridingAgt = false
          // this.fetchItem = false
          // this.fetchSubItem = true
          break
        }
        case 3: {
          this.tabMenu = 2
          // this.ids.itemNo = null
          this.commissionReviewTab = true
          this.overridingAgtReviewTab = true
          // this.itemReviewTab = false
          // this.subItemReviewTab = false
          this.fetchCommission = false
          this.fetchOverridingAgt = false
          // this.fetchItem = true
          // this.fetchSubItem = false
          break
        }
        case 2: {
          this.tabMenu = 1
          this.ids.ovrInter = null
          this.commissionReviewTab = true
          this.overridingAgtReviewTab = false
          // this.itemReviewTab = false
          // this.subItemReviewTab = false
          this.fetchCommission = false
          this.fetchOverridingAgt = true
          // this.fetchItem = false
          // this.fetchSubItem = false
          break
        }
        default: {
          this.tabMenu = 0
          this.ids.commissionNo = null
          this.ids.effDate = null
          this.ids.polType = null
          this.ids.queryCommission = false
          this.ids.queryOvrAgt = false
          this.commissionReviewTab = false
          this.overridingAgtReviewTab = false
          // this.itemReviewTab = false
          // this.subItemReviewTab = false
          this.fetchCommission = true
          this.fetchOverridingAgt = false
          // this.fetchItem = false
          // this.fetchSubItem = false
        }
      }
    },
    doCommissionReview(data) {
      this.ids.inter = this.inter
      this.ids.commissionNo = data.commissionNo
      this.ids.effDate = data.effDateTime
      this.ids.polType = data.polType
      this.ids.queryCommission = false
      this.commissionReviewTab = true
      this.fetchCommission = false
      this.fetchOverridingAgt = true
      this.tabMenu = 1
    },
    doCommissionQuery(data) {
      this.ids.inter = this.inter
      this.ids.commissionNo = data.commissionNo
      this.ids.effDate = data.effDateTime
      this.ids.polType = data.polType
      this.ids.queryCommission = true
      this.commissionReviewTab = true
      this.fetchCommission = false
      this.fetchOverridingAgt = true
      this.tabMenu = 1
    },
    doCommissionNew() {
      this.ids.inter = this.inter
      this.ids.commissionNo = 'new'
      this.commissionReviewTab = true
      this.fetchCommission = false
      this.fetchOverridingAgt = false
      this.tabMenu = 1
    },
    doOverridingAgtReview(data) {
      this.ids.inter = data.inter
      this.ids.commissionNo = data.commissionNo
      this.ids.ovrInter = data.ovrInter
      this.ids.queryOvrAgt = false
      this.commissionReviewTab = true
      this.overridingAgtReviewTab = true
      this.fetchCommission = false
      this.fetchOverridingAgt = false
      // this.fetchItem = true
      this.tabMenu = 2
    },
    doOverridingAgtQuery(data) {
      this.ids.inter = data.inter
      this.ids.commissionNo = data.commissionNo
      this.ids.ovrInter = data.ovrInter
      this.ids.queryOvrAgt = true
      this.commissionReviewTab = true
      this.overridingAgtReviewTab = true
      this.fetchCommission = false
      this.fetchOverridingAgt = false
      // this.fetchItem = true
      this.tabMenu = 2
    },
    doOverridingAgtNew() {
      this.ids.ovrInter = 'new'
      this.commissionReviewTab = true
      this.overridingAgtReviewTab = true
      this.fetchCommission = false
      this.fetchOverridingAgt = false
      // this.fetchItem = false
      this.tabMenu = 2
    }
    // doItemReview(data) {
    //   this.ids.itemNo = data.itemNo
    //   this.planReviewTab = true
    //   this.overridingAgtReviewTab = true
    //   this.itemReviewTab = true
    //   this.fetchCommission = false
    //   this.fetchOverridingAgt = false
    //   this.fetchItem = false
    //   this.fetchSubItem = true
    //   this.tabMenu = 3
    // },
    // doItemNew() {
    //   this.ids.itemNo = 'new'
    //   this.planReviewTab = true
    //   this.overridingAgtReviewTab = true
    //   this.itemReviewTab = true
    //   this.fetchCommission = false
    //   this.fetchOverridingAgt = false
    //   this.fetchItem = false
    //   this.fetchSubItem = false
    //   this.tabMenu = 3
    // },
    // doSubItemReview(data) {
    //   this.ids.subItemNo = data.subItemNo
    //   this.planReviewTab = true
    //   this.overridingAgtReviewTab = true
    //   this.itemReviewTab = true
    //   this.subItemReviewTab = true
    //   this.fetchCommission = false
    //   this.fetchOverridingAgt = false
    //   this.fetchItem = false
    //   this.fetchSubItem = false
    //   this.tabMenu = 4
    // },
    // doSubItemNew() {
    //   this.ids.subItemNo = 'new'
    //   this.planReviewTab = true
    //   this.overridingAgtReviewTab = true
    //   this.itemReviewTab = true
    //   this.subItemReviewTab = true
    //   this.fetchCommission = false
    //   this.fetchOverridingAgt = false
    //   this.fetchItem = false
    //   this.fetchSubItem = false
    //   this.tabMenu = 4
    // }
  },
  components: {
    CommissionList,
    // PkgPlanList,
    CommissionForm,
    OverridingAgtList,
    OverridingAgtForm
    // PkgRiskList,
    // PkgRiskForm,
    // PkgRiskItemList,
    // PkgRiskItemForm,
    // PkgRiskSubItemList,
    // PkgRiskSubItemForm
  },
  props: {
    inter: {
      type: String,
      default: ''
    },
    interGroupCode: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>

</style>
